//@flow

import React, { Fragment } from 'react';
import { Button } from 'reactstrap';

import { Toggler } from '../UI';
import { padSAtTheEndIfPlural } from '../../lib/helpers';

type Props = {
  forMobile: boolean,
  // DesktopCom
};

StaticSearchFormWrapper.defaultProps = {
  initialOn: false,
  paxText: 'Trekker',
};

export default function StaticSearchFormWrapper(props: Props) {
  const {
    forMobile,
    DesktopComponent,
    MobileComponent,
    initialOn,
    pax,
    searchText,
    paxText,
    dateText,
  } = props;

  const forDesktop = !forMobile;

  if (forDesktop) return <DesktopComponent />;

  return (
    <Toggler initialOn={initialOn}>
      {({ on, open, close }) => {
        return (
          <Fragment>
            {on ? (
              <MobileComponent close={close} />
            ) : (
              <section className="side__panel d-block d-lg-none" onClick={open}>
                <div className="side__panel_res">
                  <Button color="search">
                    <i className="icon icon-hg-search" /> {searchText}
                  </Button>
                  <div className="search_info">
                    <span>
                      <i className="icon icon-hg-calendar" />
                      {dateText}
                    </span>
                    <span>
                      <i className="icon icon-hg-user" /> {pax}{' '}
                      {padSAtTheEndIfPlural(pax, paxText)}
                    </span>
                  </div>
                </div>
              </section>
            )}
          </Fragment>
        );
      }}
    </Toggler>
  );
}



// WEBPACK FOOTER //
// ./src/components/StaticSearchFormWrapper/StaticSearchFormWrapper.js